import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

export default function Registration() {
    const navigate = useNavigate();
    const [data, setData] = useState({
        role: 2,
        photo: null,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: value,
        });
    };

    const [selectedFile, setSelectedFile] = useState(null);
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const file = files[0];

        if (file) {
            const maxSizeInBytes = 5 * 1024 * 1024;
            if (file.size > maxSizeInBytes) {
                Swal.fire({
                    title: "File size exceeds 5 MB",
                    icon: "warning",
                });
                return;
            }
            setSelectedFile(URL.createObjectURL(file));
            setData({
                ...data,
                [name]: file
            })
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (Object.values(data).some((value) => !value && value !== 0)) {
            Swal.fire({
                icon: "warning",
                title: "Please fill all required fields",
            });
            return;
        }

        const formData = new FormData();
        Object.keys(data).forEach((key) => {
            formData.append(key, data[key]);
        });
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_BACKEND_BASE_URL}/user/registration`,
                formData
            );

            if (res.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Registration Successful",
                    timer: 1500,
                }).then(() => {
                    navigate("/login");
                });
            } else if (res.status === 409) {
                Swal.fire({
                    icon: "warning",
                    title: "This email ID is already exists",
                    timer: 1500,
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Registration failed",
                });
            }
        } catch (err) {
            console.log(err);
            Swal.fire({
                icon: "error",
                title: "Error occurred during registration",
            });
        }
    };

    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/assets/css/style.css';
        document.head.appendChild(link);
        return () => {
            document.head.removeChild(link);
        };
    }, []);

    return (
        <div className="main-wrapper wrapper-login">
            <div className="login-pagess">
                <div className="container-fluid">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-12">
                            <div className="login-logo" style={{ display: 'flex', justifyContent: 'center' }}>
                                <img src="/images/gpslogo.png" alt="img" style={{ height: '120px' }} />
                            </div>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="col-lg-7 mx-auto">
                                <div className="">
                                    <div className="login-content">
                                        <h5 className="text-center mb-3">Mutual Fund Registration</h5>

                                        <div className="login-input row">

                                            {/* Personal Details */}
                                            <div className="form-group col-md-6">
                                                <label>First Name</label>
                                                <input type="text" name="first_name" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Last Name</label>
                                                <input type="text" name="last_name" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Email</label>
                                                <input type="email" name="email" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Mobile Number</label>
                                                <input type="tel" name="phone" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Password</label>
                                                <input type="password" name="password" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Date of Birth</label>
                                                <input type="date" name="date_of_birth" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Gender</label>
                                                <select name="gender" className="form-control" onChange={handleInputChange} required>
                                                    <option value="">Select</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>PAN Number</label>
                                                <input type="text" name="pan_number" className="form-control" onChange={handleInputChange} required />
                                            </div>

                                            {/* Address */}
                                            <div className="form-group col-md-6">
                                                <label>Address Line 1</label>
                                                <input type="text" name="address_line1" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Address Line 2</label>
                                                <input type="text" name="address_line2" className="form-control" onChange={handleInputChange} />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>City</label>
                                                <input type="text" name="city" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>State</label>
                                                <input type="text" name="state" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>PIN Code</label>
                                                <input type="text" name="pin_code" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Country</label>
                                                <input type="text" name="country" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Residential Status</label>
                                                <select name="residential_status" className="form-control" onChange={handleInputChange} required>
                                                    <option value="">Select</option>
                                                    <option value="Resident">Resident</option>
                                                    <option value="NRI">NRI</option>
                                                    <option value="Foreign National">Foreign National</option>
                                                </select>
                                            </div>

                                            {/* Bank Details */}
                                            <div className="form-group col-md-6">
                                                <label>Bank Name</label>
                                                <input type="text" name="bank_name" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Branch Name</label>
                                                <input type="text" name="branch_name" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Account Number</label>
                                                <input type="text" name="account_number" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Account Type</label>
                                                <select name="account_type" className="form-control" onChange={handleInputChange} required>
                                                    <option value="">Select</option>
                                                    <option value="Savings">Savings</option>
                                                    <option value="Current">Current</option>
                                                    <option value="NRE">NRE</option>
                                                    <option value="NRO">NRO</option>
                                                </select>
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>IFSC Code</label>
                                                <input type="text" name="ifsc_code" className="form-control" onChange={handleInputChange} required />
                                            </div>

                                            {/* Nominee */}
                                            <div className="form-group col-md-6">
                                                <label>Nominee Name</label>
                                                <input type="text" name="nominee_name" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Relationship with Investor</label>
                                                <input type="text" name="nominee_relationship" className="form-control" onChange={handleInputChange} required />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label>Nominee DOB (if minor)</label>
                                                <input type="date" name="nominee_dob" className="form-control" onChange={handleInputChange} />
                                            </div>
                                            <div className="form-group">
                                                <label>Guardian Name & Address</label>
                                                <textarea name="guardian_details" className="form-control" onChange={handleInputChange}></textarea>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="file-input">
                                                    <input
                                                        type="file"
                                                        name="photo"
                                                        id="file-input"
                                                        accept="image/*"
                                                        className="file-input__input"
                                                        required
                                                        onChange={handleFileChange} // Handle file selection
                                                    />
                                                    <label className="file-input__label" htmlFor="file-input">
                                                        <i className="fa-solid fa-upload"></i>
                                                        <span>Upload Image</span>
                                                    </label>
                                                </div>
                                                {selectedFile && (
                                                    <div>
                                                        <div>
                                                            <img src={selectedFile} alt="Selected" style={{ width: '295px', height: '197px', objectFit: 'contain', borderRadius: '20px', border: '1px solid #d5d5d5' }} />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="login-button d-flex mt-4 gap-4">
                                            <Link to={'/login'} className="btn btn-cancel" style={{ width: '100%', display: 'initial' }}>Back</Link>
                                            {/* <a className="btn btn-cancel me-3" href="/student">Back</a> */}
                                            <button type="submit" className="btn btn-login">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
